export const ACTION_ADD_PAYOUT_REQUESTS = 'ACTION_ADD_PAYOUT_REQUESTS';

export const ACTION_CREATE_PAYOUT_REQUEST__REQUEST = 'ACTION_CREATE_PAYOUT_REQUEST__REQUEST';
export const ACTION_CREATE_PAYOUT_REQUEST__FAIL = 'ACTION_CREATE_PAYOUT_REQUEST__FAIL';
export const ACTION_CREATE_PAYOUT_REQUEST__SUCCESS = 'ACTION_CREATE_PAYOUT_REQUEST__SUCCESS';

export const ACTION_CANCEL_PAYOUT_REQUEST__REQUEST = 'ACTION_CANCEL_PAYOUT_REQUEST__REQUEST';
export const ACTION_CANCEL_PAYOUT_REQUEST__FAIL = 'ACTION_CANCEL_PAYOUT_REQUEST__FAIL';
export const ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS = 'ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS';

export const ACTION_ADD_PAYOUT_FEES = 'ACTION_ADD_PAYOUT_FEES';

export const ACTION_LOAD_PAYOUT_REQUEST_DETAILS__REQUEST = 'ACTION_LOAD_PAYOUT_REQUEST_DETAILS__REQUEST';
export const ACTION_LOAD_PAYOUT_REQUEST_DETAILS__SUCCESS = 'ACTION_LOAD_PAYOUT_REQUEST_DETAILS__SUCCESS';
export const ACTION_LOAD_PAYOUT_REQUEST_DETAILS__FAIL = 'ACTION_LOAD_PAYOUT_REQUEST_DETAILS__FAIL';

export const ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__REQUEST = 'ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__REQUEST';
export const ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__SUCCESS = 'ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__SUCCESS';
export const ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__FAIL = 'ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__FAIL';
